import { Disclosure } from "./Disclosure";
import { SectionHeading } from "./SectionHeading";
import { FAQ_ITEMS } from "./faq-data";

export { FAQ_ITEMS };

export function FAQSection() {
  return (
    <section className="relative py-12 md:py-16">
      <div className="container-narrow">
        <SectionHeading eyebrow="Perguntas frequentes" title="O que você precisa saber." />

        <div className="mx-auto mt-14 max-w-3xl">
          <div className="w-full">
            {FAQ_ITEMS.map((item, i) => (
              <Disclosure
                key={i}
                name="faq"
                className="border-border/60"
                summaryClassName="py-6 text-left text-base text-ivory hover:no-underline md:text-lg"
                contentClassName="text-base leading-relaxed text-slate-muted"
                summary={item.q}
              >
                {item.a}
              </Disclosure>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
